import React, { Component } from 'react'
import Header from "../../components/Header"
import Footer from "../../components/Footer"
import { Link } from "react-router-dom"
import serializeForm from "form-serialize"
import * as backendMembers from '../../utils/ApiRest/backendMembers'
import * as serializeJavascript from '../../utils/helpers/serializeJavascript'

class LostPassword extends Component {
  state = {
    applyLostPassword: false,
    userEmail: ''
  }

  handleSubmit = event => {
    event.preventDefault();
    const FormValues = serializeForm(event.target, { hash: true });

    if (Object.keys(FormValues).length !== 0) {
      this.setState({ applyLostPassword: true, userEmail: serializeJavascript.sanitize(FormValues).email })
      backendMembers.sendResetPwd(serializeJavascript.sanitize(FormValues).email)
      .then(response => {
      })
      .catch(error => {
      })
    }
  }

  render() {
    const { applyLostPassword, userEmail } = this.state

    return(
      <div>
        <Header userIsSuccessLogin={false} />
        <div className="aps-container-center-bloc">
          <div className="aps-section-connexion-padding">
            <div className="uk-section aps-section-connexion">
              {applyLostPassword
                ?
                  <div>
                    <h3 className="uk-text-center aps-section-lost-pwd-title">
                      Si un compte existe pour {userEmail}, un e-mail y sera envoyé contenant d&apos;autres instructions.<br />
                      Vous devrez peut-être consulter votre dossier de spams
                    </h3>
                  </div>
                :
                  <div>
                    <h3 className="uk-text-center aps-section-connexion-title">
                      Saisissez votre email pour réinitialiser le mot de passe
                    </h3>
                    <div>
                      <form onSubmit={this.handleSubmit}>
                        <div className="uk-text-center aps-section-connexion-fields-container">
                          <div className="uk-inline aps-section-connexion-input-full">
                            <span className="uk-form-icon" uk-icon="icon: user" />
                            <input
                              className="uk-input aps-section-connexion-input"
                              type="email"
                              placeholder="Email"
                              name="email"
                            />
                          </div>
                        </div>
                        <div className="uk-text-center aps-section-connexion-action-btn">
                          <button className="uk-button aps-section-connexion-action-btn-full">
                            Réinitialiser
                          </button>
                        </div>
                      </form>
                    </div>
                    <div className="uk-text-center aps-section-connexion-lost-password">
                      <Link
                        className="aps-section-connexion-lost-password-link"
                        to="/connexion"
                      >
                        Me connectez ?
                      </Link>
                    </div>
                  </div>
              }
            </div>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

export default LostPassword



// WEBPACK FOOTER //
// ./src/containers/LostPassword/index.js